import { accessCardConstants } from "@constants";

const initalState = {
  getEdit: {
    loading: false
  },
  edit: {
    processing: false,
    fail: null
  }
};

export const accessCard = (state = initalState, action) => {
  switch (action.type) {
    case accessCardConstants.GET_EDIT_REQUEST:
      return {
        ...state,
        getEdit: {
          loading: true
        }
      };
    case accessCardConstants.GET_EDIT_DONE:
      return {
        ...state,
        getEdit: {
          loading: false
        }
      };
    case accessCardConstants.EDIT_REQUEST:
      return {
        ...state,
        edit: {
          processing: true
        }
      };
    case accessCardConstants.EDIT_SUCCESS:
      return {
        ...state,
        edit: {
          processing: false
        }
      };
    case accessCardConstants.EDIT_FAILURE:
      return {
        ...state,
        edit: {
          processing: false,
          fail: action.error
        }
      };
    case accessCardConstants.RESET_EDIT_SUCCESS:
      return {
        ...state,
        edit: initalState.edit
      };
    default:
      return state;
  }
};
